<template>
  <section>
    <div class="container">
      <div class="jumbo jumbo--md" v-if="item">
        <div class="row">
          <div class="col-m-4 col-s-4 hidden-x">
            <img :src="item.img" class="img-responsive" />
            <div class="text-center">
              <router-link :to="`/item-request?type=request&model=${item.slug}`" class="button button--primary mb-15">Заявка на оборудование</router-link>
              <router-link :to="`/item-request?type=consulting&model=${item.slug}`" class="button button--outlined">Запросить консультацию</router-link>
            </div>
          </div>
          <div class="col-m-8 col-s-8">
            <article class="article mb-24 article--item">
              <h1>{{ item.title }}</h1>
              <img :src="item.img" class="img-responsive hidden-s hidden-m hidden-l" />
              <p>{{ item.description }}</p>
            </article>
            <p class="l-price">от {{ new Intl.NumberFormat().format(item.price) }} руб.</p>
            <div class="table-responsive mt-24">
              <h3 class="table__title">Технические характеристики</h3>
              <table class="table">
                <tbody>
                  <tr v-for="param in item.params">
                    <td>{{ param.name }}</td>
                    <td>{{ param.value }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="article mt-24 mb-24">
              <p>Опционально возможно изменение конфигурации оборудования - подключение дополнительных модулей, увеличение производительности. Обеспечиваем брендирование, доставку и монтаж под ключ, а также сервисное обслуживание 24/7</p>
            </div>
            <div class="flex flex-align-center flex-column hidden-s hidden-m hidden-l l-sticky-button">
              <router-link :to="`/item-request?type=request&model=${item.slug}`" class="button button--primary mb-15">Заявка на оборудование</router-link>
              <router-link :to="`/item-request?type=consulting&model=${item.slug}`" class="button button--outlined">Запросить консультацию</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="article mt-60 mb-30">
        <h3>Похожее оборудование</h3>
      </div>
      <div class="row">
        <div class="col-m-4 col-s-6" v-for="suggestedItem in suggested" :key="suggestedItem.id">
          <router-link :to="`/equipment/${suggestedItem.category}/${suggestedItem.slug}`" class="equip-item">
            <div class="equip-item__image">
              <img :src="suggestedItem.img" />
            </div>
            <div class="equip-item__title">{{ suggestedItem.title }}</div>
            <div class="equip-item__description">{{ suggestedItem.description_short }}</div>
            <div class="equip-item__price">{{ new Intl.NumberFormat().format(suggestedItem.price) }} руб.</div>
            <div class="button button--small button--outlined">Подробнее</div>
          </router-link>
        </div>
        <div class="col-m-4 col-s-12 flex flex-align-stretch">
          <router-link class="icon-card icon-card--link icon-card--full-height" to="/equip-request?type=custom">
            <div class="icon-card__title">Нужно другое оборудование?</div>
            <div class="icon-card__body">
              Произведем оборудование специально для вас - просто расскажите о задаче!
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Clients />
    <VueFooter />
  </section>
</template>
<script>
const name = 'EquipItem'

import Clients from '@/components/Clients.vue'
import VueFooter from '@/components/VueFooter.vue'

const computed = {
  item() {
    const item = this.$store.state.equipment.equipment.filter(item => {
      return item.slug == this.$route.params.slug && item.category == this.$route.params.category
    })

    if (item.length) {
      return item[0]
    }

    return null
  },
  suggested() {
    const items = this.$store.state.equipment.equipment.filter(item => {
      return item.slug != this.$route.params.slug && item.category == this.$route.params.category
    })

    if (items.length) {
      return items.slice(0, 2);
    }
  }
}

export default {
  name,
  computed,
  components: {
    Clients,
    VueFooter
  }
}

</script>
